import { fn } from '@ember/helper';
import { action } from '@ember/object';

import { ReportFragmentAction } from 'webapp/enums/enums';

import type { ReportFragmentActionData } from 'webapp/components/reports/editor-base';
import ReportsEditorBlockCtComponent from 'webapp/components/reports/editor/block-ct';
import type { Args as BaseArgs } from 'webapp/components/reports/viewer/fragment/image';
import ReportsViewerFragmentImageComponent from 'webapp/components/reports/viewer/fragment/image';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

interface Args extends BaseArgs {
	onFragmentChange: (
		fragment: ReportSlideFragment,
		action: ReportFragmentAction,
		data?: ReportFragmentActionData,
	) => Promise<unknown>;
	changeBlockFragmentToEdit: (fragment: ReportSlideFragment | null) => void;
	isBeingEdited: boolean;
}

export default class ReportsEditorFragmentBlockComponent extends ReportsViewerFragmentImageComponent<Args> {
	@action
	onFragmentChange(data?: ReportFragmentActionData) {
		return this.args.onFragmentChange(this.args.model, ReportFragmentAction.CONTENT, data);
	}
	<template>
		<div
			class="fragment fragment--block
				{{if @isBeingEdited 'fragment--block--block-being-edited'}}"
		>
			<ReportsEditorBlockCtComponent
				@model={{@model}}
				@changeBlockFragmentToEdit={{fn @changeBlockFragmentToEdit @model}}
				@onFragmentChange={{this.onFragmentChange}}
			/>
		</div>
	</template>
}
